module.exports = __webpack_public_path__ + "static/media/base.8750091f.fbx";